'use client';

import { useEffect } from 'react';
import { getConfig } from '@/utils/config/config';
import { initializeCookieListener } from '@/utils/osano/osano-cookie-helper';

export const OsanoInitializer = () => {
    useEffect(() => {
        if (!getConfig()?.services?.osano) {
            return;
        }
        initializeCookieListener();
    }, []);

    return null;
};
